import { useFeatureGate } from '@/src/services/Statsig/useFeatureGate'
import { Platform } from 'react-native'

/** @see {@link https://console.statsig.com/1G3Xqca75leoEUUlzU7xDl/gates/card_application_routes_enabled} */
export function useCardApplicationRoutesEnabled() {
  const cardApplicationRoutesFeatureGate = useFeatureGate('card_application_routes_enabled')

  return Platform.select({
    native: true,
    default:
      cardApplicationRoutesFeatureGate.loadingStatus === 'Ready'
        ? cardApplicationRoutesFeatureGate.featureGate.value
        : cardApplicationRoutesFeatureGate.loadingStatus,
  })
}

export function useLoanProStackEnabled() {
  const loanProStackFeatureGate = useFeatureGate('card_application_-_loanpro_stack_enabled')

  return loanProStackFeatureGate.loadingStatus === 'Ready'
    ? loanProStackFeatureGate.featureGate.value
    : loanProStackFeatureGate.loadingStatus
}
